var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5217",
    "data-name": "Group 5217",
    transform: "translate(-1747 -245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6218",
    "data-name": "Path 6218",
    d: "M14,0A14,14,0,1,0,28,14,14.021,14.021,0,0,0,14,0Zm4.12,8.065a.2.2,0,0,1-.209.209H16.13a.79.79,0,0,0-.8.8v1.85H17.84a.2.2,0,0,1,.209.244l-.209,2.618a.225.225,0,0,1-.209.209h-2.3v8.728a.2.2,0,0,1-.209.209H11.94a.2.2,0,0,1-.209-.209V14.035H10.125a.2.2,0,0,1-.209-.209V11.172a.2.2,0,0,1,.209-.209h1.606V8.414A3.2,3.2,0,0,1,14.943,5.2h3a.2.2,0,0,1,.209.209V8.065Z",
    transform: "translate(1747 245)",
    fill: "#0a7da7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.6eaf520f950d20a9f5d025aa96a5d020.svg";
export { ForwardRef as ReactComponent };